import React from 'react';
import _get from 'lodash/get';
import SupportiveMessage, {
  SupportiveMessageColor,
  SupportiveMessageIconColor,
  SupportiveMessageIconType,
  SupportiveMessageType,
} from '@lib/components/SupportiveMessage/SupportiveMessage';
import FormTemplateFieldNames from '@lib/enums/fieldNames/formTemplateFieldNames';
import { ComponentProps } from '../types';

export default function ImportantNoticePreview(props: ComponentProps) {
  const { t } = props;
  const text = _get(
    props,
    `${FormTemplateFieldNames.Options}.0.${FormTemplateFieldNames.Values}.0`,
    '',
  );
  return (
    <SupportiveMessage
      text={text || t('important-notice-message')}
      leftIcon="warning"
      color={SupportiveMessageColor.Yellow}
      iconColor={SupportiveMessageIconColor.Inner}
      iconType={SupportiveMessageIconType.FilledWithBorder}
      type={SupportiveMessageType.FilledWithBorder}
    />
  );
}
